import React from 'react';

const FeedbacksListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_FEEDBACK',
    'ROLE_FEEDBACK_LIST',
    'ROLE_FEEDBACK_SHOW',
    'ROLE_SUPER_ADMIN'
  ],
  routes: [
    {
      path: '/feedbacks',
      exact: true,
      component: React.lazy(() => import('./feedbacks_list'))
    },
    {
      path: '/feedbacks/answers',
      component: React.lazy(() => import('./feedbacks_answer'))
    }
  ]
};

const FeedbacksReceiverConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_COMMENT',
    'ROLE_COMMENT_LIST',
    'ROLE_COMMENT_SHOW',
    'ROLE_SUPER_ADMIN'
  ],
  routes: [
    {
      path: '/feedbacks/receivers',
      component: React.lazy(() => import('./feedbacks_receiver'))
    }
  ]
};

export { FeedbacksListConfig, FeedbacksReceiverConfig };
